import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'sub-processors',
  templateUrl: './sub-processors.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatExpansionModule]
})
export default class SubProcessorsComponent {

  // constructor(public ss: SharedService) {
  //   this.ss.title.setTitle('cloudigo | Sub-processes');
  // }

}
